import { UPDATE_PASSWORD_FROM_RECOVERY_TOKEN } from '../Types';

export const updatePasswordFromRecoveryToken = (email, token, password) => {
  return (dispatch) => {
    const action = {
      type: UPDATE_PASSWORD_FROM_RECOVERY_TOKEN,
      request: async (apiClient) => {
        return await apiClient.user.updatePasswordFromRecoveryToken(
          encodeURIComponent(email),
          {
            passwordRecoveryToken: token,
            newPassword: password,
          },
        );
      },
    };

    dispatch(action);
  };
};

export default updatePasswordFromRecoveryToken;
